import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AllItems from "../components/Views/AllItems.jsx";
import AddForm from "../components/Views/AddForm.jsx";
import ViewForm from "../components/Views/ViewForm.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import { DEFAULT_GET_PARAMS_RATES_AND_SERVICES } from "../lib/data";
import Container from "./Container.jsx";
import axios from "axios";

class PromoContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("promo");
        this.state = {
            ...this.state,
            loading: true,
            getParams: { ...DEFAULT_GET_PARAMS_RATES_AND_SERVICES },
        };
    }

    componentDidMount = async () => {
        await this.getAuxData();
    };

    getBackLink = () => this.datasource.routes().home;

    getAll = (params = {}) => {
        const path = this.datasource.dataPath + "/" + this.modelName;

        return axios.get(path, { params }).then((response) => response.data);
    };

    getAllItems = (params) =>
        this.getAll(params)
            .then((resData) => {
                this.setState({
                    AllItems: resData,
                    loading: false,
                });
            })
            .catch((error) => {
                this.handleSearchError(error.response);
            });

    paramsChangeHandler = (newParams) => this.getAllItems(newParams);
    setCustomLoading = (loading) =>
        this.setState((state) => ({ ...state, loading: loading }));

    render = () => {
        const notPermitted = this.checkAvailability();

        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }
        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <AllItems
                        title="Список промокодов"
                        columns={{
                            id: "id",
                            name: "Промокод",
                            // quantity: "Количество",
                            start_date: "Период проживания c",
                            end_date: "Период проживания по",
                            using_start_date: "Период бронирования с",
                            using_end_date: "Период бронирования по",
                            active: "Активен",
                        }}
                        addRoute={routes.add}
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        loading={this.state.loading}
                        viewAction={this.getViewLink}
                        editAction={this.getEditLink}
                        toggleAction={this.toggleItem}
                        removeAction={this.removeItem}
                        getParams={this.state.getParams}
                        paramsChangeHandler={this.paramsChangeHandler}
                        updateParticularItem={this.updateParticularItem}
                        thisPromo={true}
                        hotelId={this.datasource.baseId}
                        reload={this.getItem}
                        defaultSortfield={"name"}
                        globalSearch={this.globalSearch}
                        updateGlobalSearch={this.updateGlobalSearch}
                        partition="promo"
                    />
                </Route>
                <Route path={routes.add()} exact>
                    <AddForm
                        title={"Новый промокод"}
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.initCurrentItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        submitAction={this.addItem}
                        fieldUpdateHandler={this.setFieldValue}
                        errorFields={this.state.error}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        setRelationsValue={this.setRelationsValue}
                        defaultRates={this.props.auxData?.rates}
                        defaultDiscountTypes={
                            this.props.auxData?.type_discount_promo
                        }
                        defaultRoomTypes={this.props.auxData?.room_types}
                    />
                </Route>
                <Route path={routes.view(":id")} exact>
                    <ViewForm
                        title="Просмотр промокода"
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.getItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        getHotelUsersLink={this.getHotelUsersLink}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        defaultRates={this.props.auxData?.rates}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <EditForm
                        loading={this.state.loading}
                        item={this.state.currentItem}
                        fields={fields}
                        errorFields={this.state.error}
                        initAction={this.getItem}
                        submitAction={this.updateItem}
                        submitActionApply={this.updateItemWithoutReload}
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                        relationsDataSource={relationsDataSource}
                        defaultRates={this.props.auxData?.rates}
                        defaultDiscountTypes={
                            this.props.auxData?.type_discount_promo
                        }
                        defaultRoomTypes={this.props.auxData?.room_types}
                        disclaimer={
                            "Внимание: Изменения в форме бронирования применяются до 10 минут"
                        }
                    />
                </Route>
            </Switch>
        );
    };
}

export default PromoContainer;
